import { Avatar, Card, Carousel } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import Image from 'next/image';
import { FC } from 'react';
import { formatPortalFacilityPath } from '../../helpers/formatters';
import { buildImageDownloadUrl } from '../../helpers/utils';
import {
  Patientportal_PortalFacilityMsg,
  useGetPortalFacilityPathsQuery,
} from '../../src/generated/graphql';
import { FacilityDescription } from './facility-description';
import styles from './facility-selection.module.scss';

interface FacilityHeaderProps {
  facility: Maybe<Patientportal_PortalFacilityMsg> | undefined;
  clinicId: Maybe<string> | undefined;
  simplified?: boolean;
}

export const FacilityHeader: FC<FacilityHeaderProps> = ({
  facility,
  clinicId,
  simplified = false,
}) => {
  const name = facility?.name;

  const logoId = facility?.logoImageId;

  const { data: portalFacilityPathsData } = useGetPortalFacilityPathsQuery({
    variables: {
      portalFacilityIds: facility?.id ? [facility.id] : [],
    },
  });

  const portalFacilityPath =
    portalFacilityPathsData?.getPortalFacilityPaths?.paths?.[0]?.portalFacilities?.slice(0, -1);
  const headerImageIds = facility?.headerImageIds;

  return (
    <div style={{ marginBottom: 8 }}>
      {!simplified && headerImageIds && headerImageIds?.length > 0 && (
        <Carousel autoplay>
          {headerImageIds?.map((imageId) => (
            <div id={'image-wrapper'} key={imageId} className={styles.facilityImageWrapper}>
              <Image
                alt={facility!.name!}
                layout={'fill'}
                objectFit={'cover'}
                className={styles.facilityImage}
                src={buildImageDownloadUrl(imageId!)}
              />
            </div>
          ))}
        </Carousel>
      )}
      <Card>
        <div className={styles.titleWrapper}>
          {logoId && (
            <div className={styles.logoWrapper}>
              <Avatar
                size={45}
                className={styles.logo}
                src={buildImageDownloadUrl(logoId)}
                alt={`Logo ${name}`}
              />
            </div>
          )}
          <div className={styles.title}>
            <Title level={2}>{name}</Title>
            <span className={styles.hierarchy}>
              {formatPortalFacilityPath(portalFacilityPath, true)}
            </span>
          </div>
        </div>
        <FacilityDescription facility={facility} />
      </Card>
    </div>
  );
};
